// extracted by mini-css-extract-plugin
module.exports = {"container":"ReasonModal_container__VL-KT","curt":"ReasonModal_curt__1IvpR"};